import React from 'react';
import Box from '@mui/material/Box';

export const CopyRight = () => {
  return (
    <Box component="span"
      sx={{
        textAlign: 'center',
        display: 'block',
        color: '#000',
        right: 0,
        bottom: 0}}>
      Copyright © Chugoku Electric Power Transmission & Distribution
       Co.,Inc. All rights reserved.
    </Box>
  );
};

export const AppVersion = () => {
  return (
    <Box component="span"
      sx={{
        textAlign: 'right',
        display: 'block',
        color: '#000',
        right: 0,
        bottom: 0,
        marginRight: '10px'}}>
      v1.00
    </Box>
  );
};
